export default "__VITE_PUBLIC_ASSET__f1f86c87__"